module.exports = __webpack_public_path__ + "fonts/gothic-a1-v8-latin-regular.dd90dff9.woff";